module.exports = __webpack_public_path__ + "static/media/tb_app_icon_unread.b7f9b006.svg";